import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export const useBrochure = () => {
  const [brochureUrl, setBrochureUrl] = useState(null);

  useEffect(() => {
    const fetchBrochure = async () => {
      const { data, error } = await supabase
        .from('files')
        .select('url')
        .eq('type', 'Brochure')
        .order('created_at', { ascending: false })
        .limit(1)
        .single();
        
      if (!error && data) {
        setBrochureUrl(data.url);
      }
    };
    
    fetchBrochure();
  }, []);

  return brochureUrl;
};
